import React from 'react';
import '../App.css';
import './home.css'
import IntroVideo from '../home/introvideo';
import Slides from '../home/slides';
import Testimonials from '../home/testimonials';
import DownloadApp from '../home/downloadapp';
import Speach from '../home/speach';

function Home() {
    return (
        <>
            <IntroVideo />
            <Slides />
            <Testimonials />
            <DownloadApp />
            <Speach />
        </>
    );
}

export default Home;
